import React from "react";
import i18n from "../../constants/i18n";

interface ImageControlInputProps {
    selectedOption: string;
    handleChange: (selectedValue: string) => void;
}

export function ImageControlInput(props: ImageControlInputProps) {
    return (
        <>
            <label>
                <input
                    type="radio"
                    name="automatic"
                    value="automatic"
                    checked={props.selectedOption === "automatic"}
                    onChange={() => {
                        props.handleChange("automatic");
                    }}
                />{" "}
                {i18n.imageControlModal.automatic}
            </label>
            <br />
            <label>
                <input
                    type="radio"
                    name="manual"
                    value="manual"
                    checked={props.selectedOption === "manual"}
                    onChange={() => {
                        props.handleChange("manual");
                    }}
                />{" "}
                {i18n.imageControlModal.manual}
            </label>
            <br />
        </>
    );
}
